"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secretValueToString = secretValueToString;
const card_1 = require("../card");
const logic_metrics_1 = require("../logic-metrics");
function secretValueToString(secret) {
    const totalCards = logic_metrics_1.LogicMetrics.DeckCards * logic_metrics_1.LogicMetrics.NumberDecks;
    if (secret.index < totalCards) {
        return new card_1.CardId(secret.value).id;
    }
    else {
        // isAce or isTen
        return secret.value.toString();
    }
}
